// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Person48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Person48: FC<Person48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M24 23.95c-2.2 0-4-.7-5.4-2.1-1.4-1.4-2.1-3.2-2.1-5.4s.7-4 2.1-5.4c1.4-1.4 3.2-2.1 5.4-2.1s4 .7 5.4 2.1c1.4 1.4 2.1 3.2 2.1 5.4s-.7 4-2.1 5.4c-1.4 1.4-3.2 2.1-5.4 2.1ZM8 40v-4.7c0-1.267.317-2.35.95-3.25A6.1 6.1 0 0 1 11.4 30c2.233-1 4.375-1.75 6.425-2.25S21.933 27 24 27s4.117.259 6.15.775c2.033.517 4.165 1.262 6.396 2.235 1.043.47 1.88 1.153 2.51 2.048.63.895.944 1.975.944 3.242V40H8Zm3-3h26v-1.7c0-.533-.158-1.041-.475-1.525-.317-.483-.708-.841-1.175-1.075-2.133-1.033-4.083-1.742-5.85-2.125A25.871 25.871 0 0 0 24 30c-1.9 0-3.75.192-5.55.575-1.8.384-3.75 1.092-5.85 2.125a2.84 2.84 0 0 0-1.15 1.075c-.3.483-.45.992-.45 1.525V37Zm13-16.05c1.3 0 2.375-.425 3.225-1.275.85-.85 1.275-1.925 1.275-3.225s-.425-2.375-1.275-3.225c-.85-.85-1.925-1.275-3.225-1.275s-2.375.425-3.225 1.275c-.85.85-1.275 1.925-1.275 3.225s.425 2.375 1.275 3.225c.85.85 1.925 1.275 3.225 1.275Z" />
        </svg>
    );
};

export default Person48;
